import {ActivatedRoute, NavigationExtras, Params, Router} from "@angular/router";
import {EditingInstance, EditingService} from "../../_services/editing.service";
import {UrlHelper} from "../../helpers/url-helper";
import {Guid} from "../../helpers/guid-helper";

export abstract class EditComponent<T> {
  protected id: string;
  protected persistence: EditingInstance<T>;

  protected constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    service: EditingService<T>,
    factory: () => T
  ) {
    this.id = UrlHelper.QueryParams.edit_id ?? Guid.newGuid();
    this.persistence = service.getOrCreateInstance(this.id, factory);
    // router.navigate([], {queryParams: {edit_id: this.id}, queryParamsHandling: "merge"}).then();
  }

  protected navigate(path: string, extras?: NavigationExtras): Promise<boolean> {
    if (!extras?.queryParams) {
      extras = {queryParams: {}};
    }
    // extras.queryParamsHandling = "merge";
    extras.queryParams!.edit_id = this.id;
    return this.router.navigate([path], extras);
  }

  protected move(queryParams?: Params): Promise<boolean> {
    return this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        ...queryParams,
        edit_id: this.id
      },
      queryParamsHandling: 'merge'
    })
  }
}
